export const famousPersonsData = [
  {
    id: 1,
    name: "Barbara Liskov",
    alt: "famous person Barbara Liskov",
    title: "Computer Scientist",
    work: "MIT",
    img: "https://cse.mbstu.ac.bd/storage/13/Barbara-Liskov.jpg",
  },
  {
    id: 2,
    name: "Tim Berners-Lee",
    alt: "famous person Tim Berners-Lee",
    title: "Computer Scientist",
    img: "https://cse.mbstu.ac.bd/storage/14/Tim-Berners-Lee.jpg",
  },
  {
    id: 3,
    name: "John von Neumann",
    alt: "famous person John von Neumann ",
    title: "Computer Scientist",
    img: "https://cse.mbstu.ac.bd/storage/15/John-von-Neumann.jpg",
  },
  {
    id: 4,
    name: "Linus Torvalds",
    alt: "famous person Linus Torvalds",
    title: "Software Engineer",
    work: "Linux Foundation",
    img: "https://cse.mbstu.ac.bd/storage/16/Linus-Torvalds.jpg",
  },
  {
    id: 5,
    name: "Dennis Ritchie",
    alt: "famous person Dennis Ritchie",
    title: "Computer Scientist",
    work: "Bell Labs",
    img: "https://cse.mbstu.ac.bd/storage/17/Dennis-Ritchie.jpg",
  },
  {
    id: 6,
    name: "Ken Thompson",
    alt: " famous person Ken Thompson",
    title: "Computer Scientist",
    work: "Bell Labs",
    img: "https://cse.mbstu.ac.bd/storage/18/Ken-Thompson.jpg",
  },
  {
    id: 7,
    name: "Larry Page",
    alt: "famous person Larry Page",
    title: "Computer Scientist",
    work: "Google",
    img: "https://cse.mbstu.ac.bd/storage/19/Larry-Page.jpg",
  },
  {
    id: 8,
    name: "Sergey Brin",
    alt: "famous person Sergey Brin",
    title: "Computer Scientist",
    work: "Google",
    img: "https://cse.mbstu.ac.bd/storage/20/Sergey-Brin.jpg",
  },
];
